import _ from 'lodash';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { last } from 'rxjs/operators';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { TablesPresetOptionSchema } from 'app/campaign/structure/tables';
import { TablesImportService } from '../../services/tables-import.service';
import { SeatsPresetOptionSchema } from 'app/campaign/structure/seats';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-tables-import',
  templateUrl: './tables-import.component.html',
  styleUrls: ['./tables-import.component.scss']
})
export class TablesImportComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public schema: any = [TablesPresetOptionSchema, SeatsPresetOptionSchema];
  public sampleFile: string = "/files/sample_tables_import.xlsx";
  public readmore: boolean = false;

  public import: FormControl = new FormControl(null, []);
  public tables: FormArray = new FormArray([], []);
  public seats: FormArray = new FormArray([], []);

  public confirm: boolean = true;
  public confirmDisabled: boolean = true;
  public closeButton: boolean = false;

  public eventId: any = null;
  
  constructor(
    private store: Store,
    private dialogService: DialogService,
    private tablesImportService: TablesImportService,
  ) { }

  ngOnInit(): void {
    this.dialog$.subscribe((dialog) => {
      this.eventId = dialog.initialState.eventId
    })
  }

  onChangeData(data) {
    this.confirm = true;

    if(data.errors) {
      this.confirmDisabled = true;
    } else {
      this.tables = data.tables;
      this.seats = data.seats;
      this.confirmDisabled = false;
    }
  }

  onConfirm(dialog) {
    this.confirm = false;
    this.closeButton = true;
  }

  onClose(dialog) {
    const group: FormGroup = new FormGroup({
      tables: this.tables,
      seats: this.seats,
    })

    this.tablesImportService.addTableList(this.eventId, group).pipe(
      last(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.close(dialog, true);
      window['ticketingAndGuestsModal'].showTablesPage();
    })
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);
  }

  onToggleReadMore() {
    this.readmore = !this.readmore;
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }
}
